import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
    BaseSiteLayoutModule,
    DayjsModule,
    DeliveryTimeModule,
    DisplayCurrencyModule,
    DropIndicatorDirective,
    DropzoneDirective,
    PurchaseRequisitionDeliveryStatusDisplayComponent,
    PurchaseRequisitionOrderStatusDisplayComponent,
    PurchaseRequisitionStatusDisplayComponent,
    RequiredUtilsModule,
} from '@lib/util';
import {
    IimAutocompleteModule,
    IimBpmnViewerModule,
    IimCardModule,
    IimDatepickerModule,
    IimDecimalInputV2Component,
    IimMarkRequiredModule,
    IimSpinnerModule,
} from '@iim-angular/components';
import { CompanyAddressModule } from '@lib/address';
import { IimArticleModule } from '@lib/article';
import { RouterModule } from '@angular/router';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DemandShippingDisplayComponent } from './util/demand-shipping-display/demand-shipping-display.component';
import { DemandSupplierDisplayComponent } from './util/demand-supplier-display/demand-supplier-display.component';
import { PersonModule } from '@lib/user';
import { MatButtonModule } from '@angular/material/button';
import { CreateDemandComponent } from './create/create-demand.component';
import { DemandAddProductComponent } from './display/content/add-product/demand-add-product.component';
import { DemandContentComponent } from './display/content/demand-content.component';
import { DemandEditProductComponent } from './display/content/edit-product/demand-edit-product.component';
import { DemandAddProductDataComponent } from './display/content/add-product/add-product-data/demand-add-product-data.component';
import { DemandAddProductDeliveryComponent } from './display/content/add-product/add-product-delivery/demand-add-product-delivery.component';
import { DemandAddProductPriceComponent } from './display/content/add-product/add-product-price/demand-add-product-price.component';
import { DemandFormEntryComponent } from './util/create-demand-form-entry/demand-form-entry.component';
import { DemandAddProductDataInputComponent } from './display/content/add-product/add-product-data/input/demand-add-product-data-input.component';
import { DemandProductPriceInputComponent } from './display/content/add-product/add-product-price/input/demand-product-price-input.component';
import { DemandProductDeliveryInputComponent } from './display/content/add-product/add-product-delivery/input/demand-product-delivery-input.component';
import {
    CopyToClipboardModule,
    DebugModule,
    FileDownloadModule,
    HighlightValidationError,
    PdfPreviewComponent,
} from '@lib/core';
import { MatChipsModule } from '@angular/material/chips';
import { ActivityDisplayModule } from '@lib/comment';
import { DemandPriceComponent } from './display/content/demand-price/demand-price.component';
import { UnitModule, UnitSelectionModule } from '@lib/unit';
import { AccountingSelectionModule } from '@lib/accounting';
import { SiteSelectionComponent } from '@lib/customer-site';
import { DemandActitvityComponent } from './display/content/demand-actitvity/demand-actitvity.component';
import { PurchaseRequisitionProcessDisplayButtonComponent } from './purchase-requisition-process-display-button/purchase-requisition-process-display-button.component';
import { PurchaseRequisitionProcessDisplayComponent } from './purchase-requisition-process-display/purchase-requisition-process-display.component';
import { WorkflowUtilsModule } from '@lib/workflow-integration';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { SupplierContactNamePipe } from '@lib/supplier';
import { ApprovalOverviewComponent } from '@lib/approval';
import { ClientErpTransmissionModule } from '@lib/client';
import { DemandTransmissionInfoComponent } from './display/content/demand-transmission-info/demand-transmission-info.component';
import { AclModule } from '@lib/acl';
import { DemandSupplierDeliveryConditionComponent } from './util/demand-supplier-display/demand-supplier-delivery-condition/demand-supplier-delivery-condition.component';
import { DeliveryConditionsModule } from '@lib/delivery-conditions';
import { DemandSupplierPaymentTermComponent } from './util/demand-supplier-display/demand-supplier-payment-term/demand-supplier-payment-term.component';
import { TextModuleSelectionComponent } from '@lib/shared/text-module';
import { DemandAdditionalCostComponent } from './display/content/additional-costs/demand-additional-cost.component';
import {
    DocumentItemAccountingComponent,
    DocumentItemActionComponent,
    DocumentItemAttachmentComponent,
    DocumentItemAttributeComponent,
    DocumentItemComponent,
    DocumentItemDescriptionComponent,
    DocumentItemLabelComponent,
    DocumentItemNameComponent,
    DocumentItemNoteComponent,
    DocumentItemNoteInternalComponent,
    DocumentItemPriceComponent,
    DocumentItemValueComponent,
    DocumentLayoutComponent,
    DocumentSidemenuAttachmentComponent,
    DocumentSidemenuCardComponent,
    DocumentSidemenuSectionActionComponent,
    DocumentSidemenuSectionComponent,
    DocumentSidemenuSectionEmptyMessageComponent,
    DocumentSidemenuSectionHeaderComponent,
} from '@lib/document';
import { ProcessChainRelatedDocumentComponent } from '@lib/process-chain';
import { ClassificationSelectionComponent } from '@lib/classification';
import { DemandSupplierFrameworkAgreementComponent } from './util/demand-supplier-display/demand-supplier-framework-agreement/demand-supplier-framework-agreement';
import { DemandUpdateDeliveryDateDialogComponent } from './display/content/update-delivery-date-dialog/update-delivery-date-dialog.component';
import { ChangeSupplierContactDialogComponent } from './util/demand-supplier-display/change-supplier-contact-dialog/change-supplier-contact-dialog.component';
import { MaterialGroupSelectionComponent } from '@lib/material-group';
import { DemandSupplierIncotermComponent } from './util/demand-supplier-display/demand-supplier-incoterm/demand-supplier-incoterm.component';

@NgModule({
    imports: [
        CommonModule,
        DisplayCurrencyModule,
        TranslateModule,
        BaseSiteLayoutModule,
        IimCardModule,
        CompanyAddressModule,
        IimSpinnerModule,
        IimArticleModule,
        RouterModule,
        MatStepperModule,
        ReactiveFormsModule,
        UnitModule,
        DeliveryTimeModule,
        DayjsModule,
        RequiredUtilsModule,
        MatCheckboxModule,
        IimDecimalInputV2Component,
        IimDatepickerModule,
        PersonModule,
        FormsModule,
        MatButtonModule,
        FileDownloadModule,
        HighlightValidationError,
        IimMarkRequiredModule,
        MatChipsModule,
        ActivityDisplayModule,
        CopyToClipboardModule,
        UnitSelectionModule,
        AccountingSelectionModule,
        SiteSelectionComponent,
        DebugModule,
        IimBpmnViewerModule,
        IimSpinnerModule,
        WorkflowUtilsModule,
        MatTooltipModule,
        ClientErpTransmissionModule,
        IimAutocompleteModule,
        AclModule,
        DeliveryConditionsModule,
        DropzoneDirective,
        DropIndicatorDirective,
        DemandSupplierPaymentTermComponent,
        DemandSupplierIncotermComponent,
        TextModuleSelectionComponent,
        DemandAdditionalCostComponent,
        DocumentItemComponent,
        DocumentItemNameComponent,
        DocumentItemDescriptionComponent,
        DocumentItemPriceComponent,
        DocumentItemLabelComponent,
        DocumentItemValueComponent,
        DocumentItemAttributeComponent,
        DocumentItemNoteComponent,
        DocumentItemAttachmentComponent,
        DocumentItemNoteInternalComponent,
        DocumentItemAccountingComponent,
        ClassificationSelectionComponent,
        MaterialGroupSelectionComponent,
        DocumentItemActionComponent,
        DemandSupplierFrameworkAgreementComponent,
        PurchaseRequisitionOrderStatusDisplayComponent,
        PurchaseRequisitionDeliveryStatusDisplayComponent,
        PurchaseRequisitionStatusDisplayComponent,
        DocumentLayoutComponent,
        DocumentSidemenuSectionComponent,
        DocumentSidemenuSectionHeaderComponent,
        DocumentSidemenuAttachmentComponent,
        DocumentSidemenuCardComponent,
        DocumentSidemenuSectionActionComponent,
        DocumentSidemenuSectionEmptyMessageComponent,
        ProcessChainRelatedDocumentComponent,
        ApprovalOverviewComponent,
        PdfPreviewComponent,
        MatRadioModule,
        SupplierContactNamePipe,
    ],
    declarations: [
        CreateDemandComponent,
        DemandAddProductComponent,
        DemandContentComponent,
        DemandEditProductComponent,
        DemandAddProductDataComponent,
        DemandAddProductDeliveryComponent,
        DemandAddProductPriceComponent,
        DemandFormEntryComponent,
        DemandShippingDisplayComponent,
        DemandSupplierDisplayComponent,
        DemandAddProductDataInputComponent,
        DemandProductPriceInputComponent,
        DemandProductDeliveryInputComponent,
        DemandPriceComponent,
        DemandActitvityComponent,
        PurchaseRequisitionProcessDisplayButtonComponent,
        PurchaseRequisitionProcessDisplayComponent,
        DemandTransmissionInfoComponent,
        DemandSupplierDeliveryConditionComponent,
        DemandUpdateDeliveryDateDialogComponent,
        ChangeSupplierContactDialogComponent,
    ],
    exports: [DemandContentComponent],
})
export class DemandModule {}
